(function () {
  if (window.variantOptionFilterInitialized) return;
  window.variantOptionFilterInitialized = true;

  const selectors = {
    variantSelects: 'variant-selects',
    variantsJson: '[data-variant-combinations]',
    radio: 'input[type="radio"][data-option-position]',
    select: 'select',
  };

  function getVariants(container) {
    const script = container.querySelector(selectors.variantsJson);
    if (!script) return [];

    try {
      return JSON.parse(script.textContent).filter((variant) => Array.isArray(variant.options));
    } catch (error) {
      console.warn('Unable to parse variant combinations.', error);
      return [];
    }
  }

  function getGroups(container) {
    const radioGroups = Array.from(container.querySelectorAll('fieldset')).filter((fieldset) =>
      fieldset.querySelector(selectors.radio)
    );
    const selectGroups = Array.from(container.querySelectorAll(selectors.select)).filter((select) =>
      select.querySelector('[data-option-position]')
    );

    return [...radioGroups, ...selectGroups].sort((a, b) => {
      const aInput = a.querySelector('[data-option-position]');
      const bInput = b.querySelector('[data-option-position]');
      return Number(aInput?.dataset.optionPosition || 0) - Number(bInput?.dataset.optionPosition || 0);
    });
  }

  function getGroupControls(group) {
    if (group.matches(selectors.select)) {
      return Array.from(group.querySelectorAll('[data-option-position]'));
    }

    return Array.from(group.querySelectorAll(selectors.radio));
  }

  function getControlValue(control) {
    return control.dataset.optionValue || control.value;
  }

  function escapeCssIdentifier(value) {
    if (window.CSS?.escape) return CSS.escape(value);
    return value.replace(/["\\]/g, '\\$&');
  }

  function getSelectedValues(groups) {
    return groups.map((group) => {
      if (group.matches(selectors.select)) {
        const selectedOption = group.selectedOptions[0];
        return selectedOption ? getControlValue(selectedOption) : null;
      }

      const checkedInput = group.querySelector(`${selectors.radio}:checked`);
      return checkedInput ? getControlValue(checkedInput) : null;
    });
  }

  function hasRegisteredCombination(variants, selectedValues, positionIndex, value) {
    return variants.some((variant) => {
      if (variant.options[positionIndex] !== value) return false;

      for (let index = 0; index < positionIndex; index += 1) {
        if (selectedValues[index] && variant.options[index] !== selectedValues[index]) return false;
      }

      return true;
    });
  }

  function setControlHidden(control, hidden) {
    control.hidden = hidden;

    if (control.tagName === 'OPTION') {
      control.disabled = hidden;
      return;
    }

    const label = control.id ? document.querySelector(`label[for="${escapeCssIdentifier(control.id)}"]`) : null;
    if (label) label.hidden = hidden;
  }

  function selectFirstVisibleControl(group) {
    const controls = getGroupControls(group).filter((control) => !control.hidden);
    const firstVisible = controls[0];
    if (!firstVisible) return false;

    if (group.matches(selectors.select)) {
      if (group.value === firstVisible.value) return false;
      group.value = firstVisible.value;
      firstVisible.selected = true;
      return true;
    }

    if (firstVisible.checked) return false;
    firstVisible.checked = true;
    return true;
  }

  function syncSelectedLabels(container) {
    getGroups(container).forEach((group) => {
      if (!group.matches('fieldset')) return;

      const selectedValue = group.querySelector('[data-selected-value]');
      const checkedInput = group.querySelector(`${selectors.radio}:checked`);
      if (selectedValue && checkedInput) selectedValue.textContent = checkedInput.value;
    });
  }

  function updateVariantOptionVisibility(container) {
    const variants = getVariants(container);
    if (!variants.length) return false;

    const groups = getGroups(container);
    let changedSelection = false;
    let selectedValues = getSelectedValues(groups);

    groups.forEach((group, positionIndex) => {
      getGroupControls(group).forEach((control) => {
        const isRegistered = hasRegisteredCombination(variants, selectedValues, positionIndex, getControlValue(control));
        setControlHidden(control, !isRegistered);
      });

      const selectedControl = group.matches(selectors.select)
        ? group.selectedOptions[0]
        : group.querySelector(`${selectors.radio}:checked`);

      if (!selectedControl || selectedControl.hidden) {
        changedSelection = selectFirstVisibleControl(group) || changedSelection;
        selectedValues = getSelectedValues(groups);
      }
    });

    syncSelectedLabels(container);
    return changedSelection;
  }

  function getSelectedControl(group) {
    if (group.matches(selectors.select)) return group;
    return group.querySelector(`${selectors.radio}:checked`);
  }

  function scheduleVariantUpdate(container) {
    if (container.dataset.variantOptionFilterSyncing === 'true') return;

    container.dataset.variantOptionFilterSyncing = 'true';
    window.requestAnimationFrame(() => {
      delete container.dataset.variantOptionFilterSyncing;

      const selectedControls = getGroups(container).map(getSelectedControl).filter(Boolean);
      const selectedControl = selectedControls[selectedControls.length - 1];
      selectedControl?.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function handleContainer(container) {
    if (!container) return;
    if (updateVariantOptionVisibility(container)) scheduleVariantUpdate(container);
  }

  function handleAddedNode(node) {
    if (!(node instanceof Element)) return;

    if (node.matches(selectors.variantSelects)) {
      handleContainer(node);
      return;
    }

    node.querySelectorAll?.(selectors.variantSelects).forEach(handleContainer);
  }

  function initialize() {
    document.querySelectorAll(selectors.variantSelects).forEach(handleContainer);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach(handleAddedNode);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener(
    'change',
    (event) => {
      const container = event.target.closest(selectors.variantSelects);
      if (!container) return;
      if (updateVariantOptionVisibility(container)) scheduleVariantUpdate(container);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(selectors.variantSelects).forEach(handleContainer);
  });
})();
